// extracted by mini-css-extract-plugin
module.exports = {"list":"usp-list_list__jx3qX","active":"usp-list_active__wqefZ","inactive":"usp-list_inactive__3Jw6e","uspItem":"usp-list_uspItem__1bQlA"};